import { hasSplashback, hasWorktop } from '@bulthaup/api/entities/project';
import { Card, Grid, Stack, Title } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';

import { trpc } from '../../../../../services/trpc';
import { ConstructionSiteCompliantSection } from './-construction-site-compliant-section';
import { CustomerNotificationSection } from './-customer-notified-section';
import { DeliverySection } from './-delivery-section';
import { InstallationSection } from './-installation-section';
import { OrderSentSection } from './-order-sent-section';
import { ProviderNotificationSection } from './-provider-notified-section';
import { TechnicalPlanVerifiedOnSiteSection } from './-technical-plan-verified-on-site-section';

export const Route = createFileRoute('/app/projets/$slug/livraison-et-pose/')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  const { data: project } = trpc.projects.get.useQuery({ slug: params.slug });

  if (!project) {
    return null;
  }

  const projectHasWorktop = hasWorktop(project);
  const projectHasSplashback = hasSplashback(project);

  return (
    <Stack>
      <Grid gutter="md">
        <Grid.Col span={{ base: 12, md: 7, xl: 6 }}>
          <Stack gap="xl">
            <Stack>
              <Title order={3}>Livraison</Title>
              <Card>
                <DeliverySection project={project} />
              </Card>
            </Stack>
            <Stack>
              <Title order={3}>Pose</Title>
              <Card>
                <InstallationSection project={project} />
              </Card>
            </Stack>
          </Stack>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 5, xl: 4 }}>
          <Stack>
            <Title order={3}>Commandes</Title>
            <Card>
              <OrderSentSection project={project} />
            </Card>
            <Title order={3}>Vérification</Title>
            <Card>
              <div className="flex flex-col gap-4">
                <TechnicalPlanVerifiedOnSiteSection project={project} />
                <ConstructionSiteCompliantSection project={project} />
              </div>
            </Card>
            <Card>
              <ProviderNotificationSection
                project={project}
                hasWorktop={projectHasWorktop}
                hasSplashback={projectHasSplashback}
              />
            </Card>
            <Card>
              <CustomerNotificationSection project={project} />
            </Card>
          </Stack>
        </Grid.Col>
      </Grid>
    </Stack>
  );
}
